import { IconCompany, IconUsers } from '@chilipiper/icons/figma-generated/src/icon'
import { cdpRoutes } from '@chilipiper/cdp-pages/src/host/cdpHost'
import { NavLink } from '../../types'

type CdpFlags = {
  isPublicCdpEnabled: boolean
  isInternalCdpEnabled: boolean
}

/**
 * The CDP's Company and People pages in the left nav, as admin-center's CDP section lists them: the
 * customer pair under publicCdp, the internal pair under internalCdp, and the customer pair
 * labelled apart when a tenant has both.
 */
export const cdpNavLinks = ({ isPublicCdpEnabled, isInternalCdpEnabled }: CdpFlags): NavLink[] => {
  const routes = cdpRoutes('chilical')
  const customer = isInternalCdpEnabled ? ' (customer)' : ''
  const customerPair: NavLink[] = [
    {
      label: `Companies${customer}`,
      icon: IconCompany,
      path: routes.customerCompanies,
      dataId: 'left-nav-customer-companies',
    },
    {
      label: `People${customer}`,
      icon: IconUsers,
      path: routes.customerPeople,
      dataId: 'left-nav-customer-people',
    },
  ]
  const internalPair: NavLink[] = [
    {
      label: 'Companies',
      icon: IconCompany,
      path: routes.companies,
      dataId: 'left-nav-cdp-companies',
    },
    {
      label: 'People',
      icon: IconUsers,
      path: routes.people,
      dataId: 'left-nav-cdp-people',
    },
  ]
  return [
    ...(isPublicCdpEnabled ? customerPair : []),
    ...(isInternalCdpEnabled ? internalPair : []),
  ]
}
